import Fetch from '@/services/fetch/Fetch';
import { envToBaseUrl } from '@/utils/env';
import { useState } from 'react';
import {
  InvalidateQueryFilters,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { toast } from 'sonner';
import { z } from 'zod';
import CreateUserForm from './CreateUserForm';
import { UserutilsHook, formSchema, ROLES, NONE_VALUE } from './userUtilsHook';

export function CreateUser() {
  const [loading, setLoading] = useState(false);
  const { markets, form, env } = UserutilsHook();
  const queryClient = useQueryClient();

  const createUserMutation = useMutation({
    mutationFn: async (form: z.infer<typeof formSchema>) => {
      setLoading(true);

      const dataToSend = {
        ...form,
        marketRestrictions: form.marketRestrictions.includes(NONE_VALUE)
          ? []
          : form.marketRestrictions,
      };

      await Fetch.json(`${envToBaseUrl(env)}/roles/create`, {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      });
    },
    onSuccess: async () => {
      toast.success('Successfully created new user');

      await queryClient.invalidateQueries([
        'list_all_users',
      ] as InvalidateQueryFilters);
    },
    onError: (error) => {
      toast.error(error.message);
    },
    onSettled: () => {
      setLoading(false);
      form.reset({});
    },
  });

  function onSubmit(data: z.infer<typeof formSchema>) {
    createUserMutation.mutate(data);
  }

  return (
    <CreateUserForm
      form={form}
      onSubmit={form.handleSubmit(onSubmit)}
      roles={ROLES}
      markets={markets}
      loading={loading}
      title='Create user'
    />
  );
}
